module.exports = __webpack_public_path__ + "img/import_contacts_video.8502a50f.png";